import React from 'react';
import FileBrowser from '@/components/efile/FileBrowser';

const MyDeskKanban = () => {
  return (
    <FileBrowser 
      apiEndpoint="/api/efile/my-desk"
      pageTitle="My Desk"
      pageDescription="Manage your active files and pending actions"
      userColumnLabel="Current Desk"
      defaultViewMode="grid"
      serverSideFiltering={false}
      enableMoveToFolder={true}
      showDeskSwitch={true}
    />
  );
};

export default MyDeskKanban;
